export default function setupTooltip () {
  $(document).tooltip({
    items: '[data-tooltip-content]',
    content () {
      return $(this).data('tooltip-content')
    },
  })
}
